// eslint-disable-next-line no-restricted-imports
import common from "./common";
import VisitorService from "./visitor";
import MobileService from "./mobile";
import ApplePayService from "./applePay";
import OrderingService from "./ordering";
import PpiService from "./ppi";
import PublicConnect from "./connect";
import auth from "./auth";
import vendor from "./vendor";
import menu from "./menu";
import payments from "./payments";
import featureFlags from "./featureFlags";

export default {
  ...common,
  ...VisitorService,
  ...MobileService,
  ...ApplePayService,
  ...OrderingService,
  ...PpiService,
  ...PublicConnect,
  ...auth,
  ...vendor,
  ...menu,
  ...payments,
  ...featureFlags
};
